import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { t } from "../i18n";

export default function Legal({ variant }) {
  const l = t.de.legal;
  const title = variant === "privacy" ? l.privacyTitle : l.legalTitle;

  useEffect(() => { window.scrollTo(0, 0); }, [variant]);

  const sections = variant === "privacy"
    ? [
        { h: "1. Datenschutz auf einen Blick", p: "Der Schutz Ihrer persönlichen Daten ist uns wichtig. Diese Datenschutzerklärung informiert Sie über die Erhebung und Verarbeitung personenbezogener Daten auf dieser Website." },
        { h: "2. Verantwortliche Stelle", p: "Verantwortlich für die Datenverarbeitung ist CLEANSORA. Die konkreten Kontaktdaten werden hier ergänzt." },
        { h: "3. Kontaktformular", p: "Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben zwecks Bearbeitung der Anfrage bei uns gespeichert." },
        { h: "4. Ihre Rechte", p: "Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer gespeicherten Daten." },
      ]
    : [
        { h: "Angaben gemäß § 5 TMG", p: "CLEANSORA – Gebäude- & Solarreinigung. Die vollständigen Anbieterangaben werden hier ergänzt." },
        { h: "Kontakt", p: "Telefon und E-Mail-Adresse werden hier ergänzt." },
        { h: "Umsatzsteuer-ID", p: "Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG wird hier ergänzt." },
        { h: "Haftung für Inhalte", p: "Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich." },
      ];

  return (
    <main data-testid="legal-page" className="min-h-screen bg-white pt-40 pb-24">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-gold-600 transition-colors mb-10">
          <ArrowLeft size={18} /> {t.de.soon.back}
        </Link>
        <h1 className="text-4xl sm:text-5xl font-light tracking-tight text-navy-900">{title}</h1>
        <p className="mt-4 text-sm text-slate-400 italic">{l.placeholder}</p>
        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="text-xl font-outfit font-medium text-navy-900 mb-3">{s.h}</h2>
              <p className="text-slate-600 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
